var path = 'app/components/pacijent/detalji.pacijenta.html';
var html = "<div id=\"page-wrapper\" class=\"gray-bg dashbard-1\"><div class=\"row border-bottom\"></div><div class=\"row border-bottom white-bg dashboard-header\"><div class=\"col-sm-6\"><img src=\"img/logo.png\"><h2>Pacijent - detalji</h2></div></div><div class=\"row\"><div class=\"col-lg-12\"><pacijent-detail id=\"vm.pacijent\"></pacijent-detail></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/pacijent/detalji.pacijenta.html
// module id = 292
// module chunks = 0